import React from "react";
import { ListGroup, ListGroupItem } from 'reactstrap'
import { FormattedMessage } from 'react-intl';
import { RemoveCertificateFromUser } from './actions/RemoveCertificateFromUser';

function ListUsersWithCertificate(props) {
  const { users, removeCertificateFromUser } = props;

  if (! Array.isArray( users ) || users.length === 0) {
    return (
      <ListGroup>
        <ListGroupItem>
          <FormattedMessage id="messages.no_data"/>
        </ListGroupItem>
      </ListGroup>
    );
  }

  const renderItem = (user, index) => {
    return (
      <ListGroupItem key={index} className="user-item">
        <span
          className="user-name">{`${user.first_name} ${user.last_name} (${user.email})`}</span>
        <RemoveCertificateFromUser removeCertificateFromUser={removeCertificateFromUser} user={user}
                             index={index}/>
      </ListGroupItem>
    );
  }

  return (
    <ListGroup className="users-with-certificate-list">
      {users.map( renderItem )}
    </ListGroup>
  );
}

export { ListUsersWithCertificate }
